var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconNotification30 = function SvgAIconNotification30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.89543 2.89543 6 4 6H26C27.1046 6 28 6.89543 28 8V22C28 23.1046 27.1046 24 26 24H4C2.89543 24 2 23.1046 2 22V8Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0107 15.6429L27 23.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9899 15.6429L3 23.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2352 6.5896L16.7034 17.5282C16.6115 17.6237 16.5115 17.7119 16.3974 17.7793C15.5358 18.2883 14.4646 18.2883 13.6031 17.7793C13.489 17.7119 13.3889 17.6237 13.297 17.5282L2.76465 6.5896",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconNotification30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiA4QzIgNi44OTU0MyAyLjg5NTQzIDYgNCA2SDI2QzI3LjEwNDYgNiAyOCA2Ljg5NTQzIDI4IDhWMjJDMjggMjMuMTA0NiAyNy4xMDQ2IDI0IDI2IDI0SDRDMi44OTU0MyAyNCAyIDIzLjEwNDYgMiAyMlY4WiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE5LjAxMDcgMTUuNjQyOUwyNyAyMy41IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTAuOTg5OSAxNS42NDI5TDMgMjMuNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTI3LjIzNTIgNi41ODk2TDE2LjcwMzQgMTcuNTI4MkMxNi42MTE1IDE3LjYyMzcgMTYuNTExNSAxNy43MTE5IDE2LjM5NzQgMTcuNzc5M0MxNS41MzU4IDE4LjI4ODMgMTQuNDY0NiAxOC4yODgzIDEzLjYwMzEgMTcuNzc5M0MxMy40ODkgMTcuNzExOSAxMy4zODg5IDE3LjYyMzcgMTMuMjk3IDE3LjUyODJMMi43NjQ2NSA2LjU4OTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";